












































































































































































import Vue from 'vue'
import PeriodSelector from '@/components/PeriodSelector.vue'
import { DatePeriod } from '@/model/DatePeriod'
import { AbsencesFilterScope, DatePeriodEnum, SecurityArea, SecurityComponent } from '@/types/enums'
import { CheckedAbsenceList } from '@/types'
import * as securityService from '@/services/security-service'
import AbsencesSearchFilterDialog from '@/components/absences/AbsencesSearchFilterDialog.vue'
import { SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'

interface ComponentData {
  isSelectAbsenceSerieActive: boolean
  isUserFilterActive: boolean
  isPeriodTypeYear: boolean
  isPeriodTypeMonth: boolean
  isPeriodTypeWeek: boolean
  isPeriodTypeWorkingWeek: boolean
  isPeriodTypeDay: boolean
  period: String
  isDisabledEditButtons: boolean
  isDisabledDeleteButtons: boolean
  isDisabledApprovedButton: boolean
  displaySearchMenu: boolean
  isFilterActive: boolean
  filterSearchString: string | null
  filterScope: AbsencesFilterScope
  panel: number[]
}

export default Vue.extend({
  name: 'SchedulerAbsencesToolbar',

  components: {
    PeriodSelector,
    AbsencesSearchFilterDialog
  },

  props: {
    drawer: Boolean,
    isFastPlanningDisabled: Boolean,
    fastPlanningButtonInactive: Boolean,
    selectedAbsence: Object as () => any,
    checkedList: Array as () => Array<CheckedAbsenceList>,
    yearPeriodScrollDate: Date,
    isFastPlanningActive: Boolean
  },

  data (): ComponentData {
    return {
      //isFastPlanningActive: false,
      isSelectAbsenceSerieActive: false,
      isUserFilterActive: false,
      isPeriodTypeYear: false,
      isPeriodTypeMonth: false,
      isPeriodTypeWeek: false,
      isPeriodTypeWorkingWeek: false,
      isPeriodTypeDay: false,
      period: DatePeriodEnum.Month,
      isDisabledEditButtons: true,
      isDisabledDeleteButtons: true,
      isDisabledApprovedButton: true,
      displaySearchMenu: false,
      isFilterActive: false,
      filterSearchString: null,
      filterScope: AbsencesFilterScope.AllAbsences,
      panel: []
    }
  },

  watch: {
    displaySearchMenu (newVal: boolean): void {
      let data: any = this.getRouteData()

      data.displaySearchMenu = newVal
      this.$router.push({name: 'absences', query: { data: JSON.stringify(data) }})
    },

    checkedList (newVal): void {
      if (newVal.length > 0) {
        this.isDisabledDeleteButtons = false
        this.isDisabledApprovedButton = false
      } else {
        this.isDisabledApprovedButton = true
        this.isDisabledDeleteButtons = true
      }
    },
    isFastPlanningDisabled (newVal): void {
      if (newVal) {
        this.$emit('activateFastPlanning', false)
      }
    },

    fastPlanningButtonInactive (): void {
      this.$emit('activateFastPlanning', false)
    },

    selectedAbsence (newVal: any): void {
      if (newVal) {
        this.isDisabledEditButtons = false
        this.isDisabledDeleteButtons = false
        this.isDisabledApprovedButton = false
      } else {
        this.isDisabledEditButtons = true
        if (this.checkedList.length > 0) {
          this.isDisabledApprovedButton = false
          this.isDisabledDeleteButtons = false
        } else {
          this.isDisabledApprovedButton = true
          this.isDisabledDeleteButtons = true
        }
      }
    },

    filterScope (): void {
      if (this.filterScope === AbsencesFilterScope.AllAbsences) {
        if (this.filterSearchString && this.filterSearchString.length > 0) {
          this.isFilterActive = true
        } else {
          this.isFilterActive = false
        }
      } else {
        this.isFilterActive = true
      }
      this.$emit('filterScopeChange', this.filterScope)

      let data: any = this.getRouteData()

      data.filterScope = this.filterScope
      this.$router.push({name: 'absences', query: { data: JSON.stringify(data) }})
    },

    filterSearchString (newVal: string | null): void {
      if (newVal) {
        this.isFilterActive = true
      } else {
        if (this.filterScope === AbsencesFilterScope.AllAbsences) {
          this.isFilterActive = false
        } else {
        }
      }
      this.$emit('filterSearchString', newVal)

      let data: any = this.getRouteData()

      data.filterSearchString = newVal
      this.$router.push({name: 'absences', query: { data: JSON.stringify(data) }})
    }
  },

  computed: {
    userFilterColor (): string {
      return this.isUserFilterActive ? 'primary' : 'secondary'
    },

    periodTypeYearColor (): string {
      return this.period === DatePeriodEnum.Year ? 'primary' : 'secondary'
    },

    periodTypeMonthColor (): string {
      return this.period === DatePeriodEnum.Month ? 'primary' : 'secondary'
    },

    periodTypeWeekColor (): string {
      return this.period === DatePeriodEnum.Week ? 'primary' : 'secondary'
    },

    periodTypeWorkingWeekColor (): string {
      return this.period === DatePeriodEnum.WorkingWeek ? 'primary' : 'secondary'
    },

    periodTypeDayColor (): string {
      return this.period === DatePeriodEnum.Day ? 'primary' : 'secondary'
    },

    fastPlanningFilterColor (): string {
      return this.isFastPlanningActive ? 'primary' : 'secondary'
    },

    absenceSerieColor (): string {
      return this.isSelectAbsenceSerieActive ? 'primary' : 'secondary'
    },

    setToolbarHeight (): string {
      if (this.$vuetify.breakpoint.smOnly) {
        return '120px'
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return '200px'
      } else {
        return '48px'
      }
    },

    filterIconColor (): string {
      return this.isFilterActive ? 'primary' : 'secondary'
    },

    showToolbarFunctions (): boolean {
      return securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)
    },
    showAddButton (): boolean {
      if( securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)) {
        return securityService.isVisible(SecurityArea.Absences, SecurityComponent.IconInsert)
      } else {
        return false
      }
    },
    showEditButton (): boolean {
      if( securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)) {
        return securityService.isVisible(SecurityArea.Absences, SecurityComponent.IconUpdate)
      } else {
        return false
      }
    },
    showDeleteButton (): boolean {
      if( securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)) {
        return securityService.isVisible(SecurityArea.Absences, SecurityComponent.IconDelete)
      } else {
        return false
      }
    },
    showApprovedButton (): boolean {
      if( securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)) {
        return securityService.isVisible(SecurityArea.Absences, SecurityComponent.IconApprove)
      } else {
        return false
      }
    },

    disabledAddButton (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconUpdate)
    },
    disabledEditButton (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconUpdate)
    },
    disabledDeleteButton (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconDelete)
    },
    disabledApprovedButton (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconApprove)
    },
  },

  methods: {
    onPeriodSelected (value: DatePeriod): void {
      this.$emit('periodSelected', value)
    },

    yearPeriodChangeDate (value: string) {
      this.$emit('yearPeriodChangeDate', value)
    },

    onUserFilterClick (): void {
      this.isUserFilterActive = !this.isUserFilterActive

      this.$emit('showOnlyEmployeesWithAbsence', this.isUserFilterActive)
    },

    onYearPeriodClick (): void {
      this.period = DatePeriodEnum.Year
      this.isPeriodTypeYear = true
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onMonthPeriodClick (): void {
      this.period = DatePeriodEnum.Month
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = true
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onWeekPeriodClick (): void {
      this.period = DatePeriodEnum.Week
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = true
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onWorkingWeekPeriodClick (): void {
      this.period = DatePeriodEnum.WorkingWeek
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = true
      this.isPeriodTypeDay = false
    },

    onDayPeriodClick (): void {
      this.period = DatePeriodEnum.Day
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = true
    },

    onAddAbsenceClick (): void {
      this.$emit('addNewAbsence')
    },

    onEditAbsenceClick (): void {
      this.$emit('editAbsence')
    },

    onDeleteAbsenceClick (): void {
      this.$emit('deleteAbsence')
    },

    onApprovedButtonClick (): void {
      this.$emit('approvedAbsences')
    },

    onToggleAbsenceDrawer (): void {
      this.$emit('toggleAbsenceDrawer')
    },

    onProjectSerieClick (): void {
      this.isSelectAbsenceSerieActive = !this.isSelectAbsenceSerieActive
      this.$emit('activateSelectAbsenceSerie', this.isSelectAbsenceSerieActive)
    },

    onFastPlanningClick (): void {
      this.$emit('activateFastPlanning', !this.isFastPlanningActive)
    },

    onFilterSearchStringChange (item: string | null) {
      this.filterSearchString = item
    },

    onFilterScopeChange (item: AbsencesFilterScope) {
      this.filterScope = item
    },

    onDisplaySearchMenu (): void {
      this.displaySearchMenu = !this.displaySearchMenu
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()
      let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]

      if(data && data.currentPeriod && data.currentPeriod.period) {
        this.period = data.currentPeriod.period
      } else if(schedulingData && schedulingData.data && schedulingData.data.currentPeriod && schedulingData.data.currentPeriod.period) {
        this.period = schedulingData.data.currentPeriod.period
      } else {
        this.period = DatePeriodEnum.Month
      }

      this.isPeriodTypeYear = this.period === DatePeriodEnum.Year
      this.isPeriodTypeMonth = this.period === DatePeriodEnum.Month
      this.isPeriodTypeWeek = this.period === DatePeriodEnum.Week
      this.isPeriodTypeWorkingWeek = this.period === DatePeriodEnum.WorkingWeek
      this.isPeriodTypeDay = this.period === DatePeriodEnum.Day
      this.displaySearchMenu = data && data.displaySearchMenu ? data.displaySearchMenu : false
      this.filterSearchString = data && data.filterSearchString ? data.filterSearchString : null
      this.filterScope = data && data.filterScope ? data.filterScope : AbsencesFilterScope.AllAbsences
    }
  },

  created (): void {
    this.setDataFromRoute()

    if(!this.showToolbarFunctions) {
      this.filterScope = AbsencesFilterScope.ApprovedAbsencesTrue
      this.$emit('filterScopeChange', this.filterScope)
    }
  }
})
